if (!customElements.get('customer-account-menu')) {
  customElements.define(
    'customer-account-menu',
    class CustomerAccountMenu extends HTMLElement {
      constructor () {
        super();
        const pagePath = window.location.pathname;
        this.pagePath = pagePath.replace(/^\/|\/$/g, '');
        this.links = this.querySelectorAll('a');

      }

      clickHandle (e) {
        if (e.target.href.indexOf(`${this.pagePath}`) !== -1) {
          if (e.target.href.indexOf('#') !== -1) {
            this.setPageState(e.target.href);
          } else {
            e.preventDefault();
            document.querySelectorAll('*[data-page][data-id]').forEach((page) => {
              if (page.getAttribute('data-id') === '') {
                page.style.display = 'block';
                window.location.hash = '';
              } else {
                page.style.display = 'none';
              }
            });
            e.target.setAttribute('data-active', 'true');
            this.links.forEach((link) => {
              if (link.href.indexOf('#') !== -1) {
                link.setAttribute('data-active', 'false');
              }
            });

          }
        }

      }

      setPageState (hash) {
        let href = hash.split('#');
        if (href[1]) {
          const id = href[1];
          const el = document.querySelector(`*[data-id=${id}]`);
          if (el) {
            el.style.display = 'block';
            document.querySelectorAll(`*[data-page]:not([data-id=${id}])`).forEach((page) => {
              page.style.display = 'none';
            });
          }
          this.querySelectorAll('a').forEach((link) => {
            if (link.href.indexOf(`#${id}`) !== -1) {
              link.setAttribute('data-active', 'true');
            } else {
              link.setAttribute('data-active', 'false');
            }
          });
        }

      }

      connectedCallback () {
        this.links.forEach((link) => {
          link.addEventListener('click', this.clickHandle.bind(this));
        });
        if (window.location.hash) {
          this.setPageState(window.location.hash);
        }
      }

      disconnectedCallback () {
        this.links.forEach((link) => {
          link.removeEventListener('click', this.clickHandle.bind(this));
        });
      }
    },
  );
}
